import { NgModule } from '@angular/core';

import { CmsConfig, provideConfig } from '@spartacus/core';
import { StoreFinderAdapter } from '@spartacus/storefinder/core';

import { DpOccStoreFinderAdapter } from './adapters';

@NgModule({
  providers: [
    { provide: StoreFinderAdapter, useClass: DpOccStoreFinderAdapter },
    provideConfig(<CmsConfig>{
      featureModules: {
        storeFinder: {
          cmsComponents: ['StoreFinderComponent'],
          module: () => import('./modules/google-maps').then((m) => m.DpGoogleMapsModule)
        },
        storeFinderTitleFeature: {
          cmsComponents: ['StoreFinderTitleComponent'],
          module: () => import('./modules/store-finder-title').then((m) => m.DpStoreFinderTitleModule)
        },
        storeFinderNavigationFeature: {
          cmsComponents: ['StoreFinderNavigationComponent'],
          module: () => import('./modules/store-finder-tabs').then((m) => m.DpStoreFinderTabsModule)
        }
      }
    })
  ]
})
export class DpStoreFinderFeatureModule {}
